var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (DateHelpers, ViewHelpers, city, fromShowGuide, linkToFair, show, shows, title, undefined) {
buf.push("<div class=\"show-related-shows-headline\">" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</div><div class=\"show-related-shows\">");
// iterate shows
;(function(){
  var $$obj = shows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

buf.push("<div class=\"show-related-show\"><div class=\"show-related-show__metadata\">");
if ( show.fair)
{
buf.push("<a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__title\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a><a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__fair-name\">" + (jade.escape(null == (jade_interp = show.fair.name) ? "" : jade_interp)) + "</a><div class=\"show-related-show__metadata__partner\"><a" + (jade.attr("href", show.partner.href, true, true)) + " class=\"entity-link\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a></div>");
if ( show.location)
{
buf.push("<a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__fair-booth\">" + (jade.escape(null == (jade_interp = show.location.display) ? "" : jade_interp)) + "</a>");
}
}
else
{
buf.push("<a" + (jade.attr("href", show.href + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"show-related-show__metadata__title\">" + (jade.escape(null == (jade_interp = ViewHelpers.title(show)) ? "" : jade_interp)) + "</a><div class=\"show-related-show__metadata__partner\"><a" + (jade.attr("href", show.partner.href, true, true)) + " class=\"entity-link\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a></div><div class=\"show-related-show__metadata__running-dates\">" + (jade.escape(null == (jade_interp = DateHelpers.timespanInWords(show.start_at, show.end_at)) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
if ( show.images)
{
buf.push("<a" + (jade.attr("href", show.href + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"show-related-show__images\">");
// iterate show.images
;(function(){
  var $$obj = show.images;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var image = $$obj[$index];

buf.push("<div class=\"show-related-show__images__image\"><img" + (jade.attr("src", image.thumb.url, true, true)) + (jade.attr("width", image.thumb.width, true, true)) + (jade.attr("height", image.thumb.height, true, true)) + (jade.attr("alt", ViewHelpers.title(show), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\"></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var image = $$obj[$index];

buf.push("<div class=\"show-related-show__images__image\"><img" + (jade.attr("src", image.thumb.url, true, true)) + (jade.attr("width", image.thumb.width, true, true)) + (jade.attr("height", image.thumb.height, true, true)) + (jade.attr("alt", ViewHelpers.title(show), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\"></div>");
    }

  }
}).call(this);

buf.push("</a>");
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

buf.push("<div class=\"show-related-show\"><div class=\"show-related-show__metadata\">");
if ( show.fair)
{
buf.push("<a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__title\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a><a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__fair-name\">" + (jade.escape(null == (jade_interp = show.fair.name) ? "" : jade_interp)) + "</a><div class=\"show-related-show__metadata__partner\"><a" + (jade.attr("href", show.partner.href, true, true)) + " class=\"entity-link\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a></div>");
if ( show.location)
{
buf.push("<a" + (jade.attr("href", show.href, true, true)) + " class=\"show-related-show__metadata__fair-booth\">" + (jade.escape(null == (jade_interp = show.location.display) ? "" : jade_interp)) + "</a>");
}
}
else
{
buf.push("<a" + (jade.attr("href", show.href + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"show-related-show__metadata__title\">" + (jade.escape(null == (jade_interp = ViewHelpers.title(show)) ? "" : jade_interp)) + "</a><div class=\"show-related-show__metadata__partner\"><a" + (jade.attr("href", show.partner.href, true, true)) + " class=\"entity-link\">" + (jade.escape(null == (jade_interp = show.partner.name) ? "" : jade_interp)) + "</a></div><div class=\"show-related-show__metadata__running-dates\">" + (jade.escape(null == (jade_interp = DateHelpers.timespanInWords(show.start_at, show.end_at)) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
if ( show.images)
{
buf.push("<a" + (jade.attr("href", show.href + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"show-related-show__images\">");
// iterate show.images
;(function(){
  var $$obj = show.images;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var image = $$obj[$index];

buf.push("<div class=\"show-related-show__images__image\"><img" + (jade.attr("src", image.thumb.url, true, true)) + (jade.attr("width", image.thumb.width, true, true)) + (jade.attr("height", image.thumb.height, true, true)) + (jade.attr("alt", ViewHelpers.title(show), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\"></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var image = $$obj[$index];

buf.push("<div class=\"show-related-show__images__image\"><img" + (jade.attr("src", image.thumb.url, true, true)) + (jade.attr("width", image.thumb.width, true, true)) + (jade.attr("height", image.thumb.height, true, true)) + (jade.attr("alt", ViewHelpers.title(show), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\"></div>");
    }

  }
}).call(this);

buf.push("</a>");
}
buf.push("</div>");
    }

  }
}).call(this);

if ( fromShowGuide && city && (title !== 'Featured Shows'))
{
buf.push("<a" + (jade.attr("href", '/shows/' + (city.slug) + '', true, true)) + " class=\"avant-garde-button-white show-related-shows__more\">See more shows in " + (jade.escape((jade_interp = city.name) == null ? '' : jade_interp)) + "</a>");
}
if ( linkToFair)
{
buf.push("<a" + (jade.attr("href", show.fair.href, true, true)) + " class=\"avant-garde-button-white show-related-shows__more\">See more booths from " + (jade.escape((jade_interp = show.fair.name) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</div>");}.call(this,"DateHelpers" in locals_for_with?locals_for_with.DateHelpers:typeof DateHelpers!=="undefined"?DateHelpers:undefined,"ViewHelpers" in locals_for_with?locals_for_with.ViewHelpers:typeof ViewHelpers!=="undefined"?ViewHelpers:undefined,"city" in locals_for_with?locals_for_with.city:typeof city!=="undefined"?city:undefined,"fromShowGuide" in locals_for_with?locals_for_with.fromShowGuide:typeof fromShowGuide!=="undefined"?fromShowGuide:undefined,"linkToFair" in locals_for_with?locals_for_with.linkToFair:typeof linkToFair!=="undefined"?linkToFair:undefined,"show" in locals_for_with?locals_for_with.show:typeof show!=="undefined"?show:undefined,"shows" in locals_for_with?locals_for_with.shows:typeof shows!=="undefined"?shows:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;